import React, { useState } from 'react';
import {
  Row,
  Col,
  Form,
  Card,
  Space,
  DatePicker,
  message,
  // Tag,
  Spin
} from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import FormItem from '@/common/FormItem';
// import { useDispatch } from 'react-redux';
import styles from '@/common/Layout/index.module.less';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import moment from 'moment';
import LocalStorage from 'utilities/localStorage';
import Layout from '@/common/Layout';
// import { getAllBatcheslist } from '../../redux/slice';

const { RangePicker } = DatePicker;

const COGSReport = () => {
  const [form] = Form.useForm();
  const [dateRange, setDateRange] = useState([moment(), moment()]);
  // const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(false);

  // const dispatch = useDispatch();

  // const handleGetBatchesList = () => {
  //   const fromDate = form.getFieldValue('fromDate')
  //     ? `${moment(form.getFieldValue('fromDate')[0]._d).format('YYYY-MM-DD')}`
  //     : '';
  //   const toDate = form.getFieldValue('fromDate')
  //     ? `${moment(form.getFieldValue('fromDate')[1]._d).format('YYYY-MM-DD')}`
  //     : '';
  //   let payload = { from_date: fromDate, to_date: toDate };
  //   dispatch(getAllBatcheslist(payload)).then((res) => {
  //     if (res?.payload?.success) {
  //       setBatches(res?.payload?.data);
  //       setViewDownload(true);
  //     }
  //   });
  // };

  const onFinish = (values) => {
    setLoading(true);
    const fromDate = values.fromDate
      ? `${moment(values.fromDate[0]._d).format('YYYY-MM-DD')}`
      : '';
    const toDate = values.fromDate
      ? `${moment(values.fromDate[1]._d).format('YYYY-MM-DD')}`
      : '';
    const user = LocalStorage.getItem('Gravity_user');

    const authToken = user?.token;

    fetch(
      `${process.env.REACT_APP_API_URL}/batch_log_book/download_cogs_detailed?from_date=${fromDate}&to_date=${toDate}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${authToken}`,
          'X-Session-Token': user?.session_token || ''
        }
      }
    )
      .then(async (response) => {
        if (!response.ok) {
          // Error responses are JSON ({ success, message }) — surface the message
          const errBody = await response.json().catch(() => null);
          throw new Error(errBody?.message || 'Failed to download report');
        }
        return response.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `FG_Detailed_Batch_Report_${fromDate}_to_${toDate}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        message.success('Report Downloaded successfully');
        form.resetFields();
        setLoading(false);
        // setViewDownload(false);
      })
      .catch((error) => {
        message.error(error?.message || 'Failed to download report');
        setLoading(false);
      });
  };

  const antIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;

  // console.log(batches);
  return (
    <Layout sider={false}>
      <Spin
        spinning={loading}
        indicator={antIcon}
        tip="Generating COGS Report"
        size="large"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Card title={'DOWNLOAD COGS REPORT'} className={styles.CustomPanel}>
            <Row gutter={24}>
              <Col xs={24} xl={12} span={12} md={24} sm={24}>
                <FormItem
                  label="Select FROM and TO date"
                  name="fromDate"
                  rules={[
                    {
                      required: true,
                      message: 'Enter Select date'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <RangePicker
                    format={'YYYY-MM-DD'}
                    onChange={(x) => {
                      setDateRange(x);
                    }}
                    disabledDate={(current) => {
                      return current && current.valueOf() > Date.now();
                    }}
                    value={dateRange}
                    style={{ width: '100%' }}
                  />
                </FormItem>
              </Col>
            </Row>
            {/* {batches?.map((batch, index) => {
              return (
                <Tag key={index}>{batch?.fg_batch_num?.packing_fg_batch}</Tag>
              );
            })} */}
          </Card>

          <br />
          <FormItem className="text-center">
            <Space>
              {/* {!viewDownload ? (
                <CustomButton
                  className={styles.inwardButton}
                  type="primary"
                  onClick={() => handleGetBatchesList()}
                >
                  View
                </CustomButton>
              ) : ( */}
              <CustomButton
                className={styles.inwardButton}
                htmlType="submit"
                type="primary"
                disabled={loading}
              >
                Download
              </CustomButton>
              {/* )} */}
              <CustomButton
                className={styles.inwardButton}
                type="primary"
                ghost
                onClick={() => history.back()}
              >
                Back
              </CustomButton>
            </Space>
          </FormItem>
        </Form>
      </Spin>
    </Layout>
  );
};
export default COGSReport;
